import { Component } from '@angular/core';

@Component({
    selector: 'db-sceleton-loading',
    templateUrl: './sceleton-loading.component.html',
    styleUrl: './sceleton-loading.component.scss',
    standalone: false
})
export class SceletonLoadingComponent {

}
